/**
 * DUO A2 Spreken rubric — 12 points/turn split across 6 criteria.
 * Mirrors apps/a2-easy-web/lib/domain/duo-rubric.ts so the SPA's
 * exam runner can render the same scoring band labels + tips without
 * reaching into the LXC code.
 */
export const PASS_THRESHOLD = 0.6;

export type CriterionKey = "ad" | "wo" | "gr" | "vl" | "helderheid" | "uit";

export type Criterion = {
  key: CriterionKey;
  label: string;
  max: number;
  /** Short Dutch tip drilled when this criterion is the weakest. */
  tip: string;
  /** Eyebrow abbreviation rendered in narrow columns. Defaults to key.toUpperCase(). */
  abbr?: string;
};

export const CRITERIA: readonly Criterion[] = [
  { key: "ad", label: "Adequaatheid", max: 3, tip: "Beantwoord altijd én de directe vraag én de rider." },
  { key: "wo", label: "Woordenschat", max: 2, tip: "Vermijd herhaling — gebruik per zin minstens 1 sterk werkwoord." },
  { key: "gr", label: "Grammatica", max: 2, tip: "Let op V2 in hoofdzinnen en werkwoord-eind in bijzinnen." },
  { key: "vl", label: "Vloeiendheid", max: 2, tip: "Gebruik de volle 60 seconden — kort 1-zinsantwoord = 0 punten." },
  { key: "helderheid", label: "Helderheid", max: 1, abbr: "hel", tip: "Verbind zinnen met en/maar/want/omdat. Gebruik hij/zij/die/dat als verwijzing." },
  { key: "uit", label: "Uitspraak", max: 2, tip: "Spreek klinkers duidelijk — ij/ei en u/uu zijn de struikelblokken." },
];

export const MAX_PER_TURN = CRITERIA.reduce((s, c) => s + c.max, 0); // 12
